import { call, put } from 'redux-saga/effects'

import { handleUnAuthorizedError } from '../../../utils/saga.util'
import { getBlogStatusStatisticsSucceed, requestFailure } from '../actions'

export function* getBlogStatisticsSaga(blogApi: {
  getBlogStatistics: (...args: any[]) => any
}) {
  try {
    const { data } = yield call(blogApi.getBlogStatistics)
    yield put(getBlogStatusStatisticsSucceed(data))
  } catch (e) {
    yield handleUnAuthorizedError(e)
    yield put(requestFailure(e))
  }
}
